/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightBookingPayment } from "./FlightBookingPayment";
import {
  FlightBookingPaymentFromJSON,
  FlightBookingPaymentFromJSONTyped,
  FlightBookingPaymentToJSON,
  FlightBookingPaymentToJSONTyped,
} from "./FlightBookingPayment";
import type { FlightBookingTraveler } from "./FlightBookingTraveler";
import {
  FlightBookingTravelerFromJSON,
  FlightBookingTravelerFromJSONTyped,
  FlightBookingTravelerToJSON,
  FlightBookingTravelerToJSONTyped,
} from "./FlightBookingTraveler";
import type { FlightBookingContact } from "./FlightBookingContact";
import {
  FlightBookingContactFromJSON,
  FlightBookingContactFromJSONTyped,
  FlightBookingContactToJSON,
  FlightBookingContactToJSONTyped,
} from "./FlightBookingContact";

/**
 *
 * @export
 * @interface FlightBookingCreateRequest
 */
export interface FlightBookingCreateRequest {
  /**
   * Explicit acknowledgement of the exact bag-bearing priced quote. Required when bags were selected; omission never authorizes a bag purchase.
   * @type {string}
   * @memberof FlightBookingCreateRequest
   */
  bagSelectionDigest?: string;
  /**
   * Explicit acknowledgement of the exact seat-bearing priced quote. Required when seats were selected; never purchase extras through an older client lacking this acknowledgement.
   * @type {string}
   * @memberof FlightBookingCreateRequest
   */
  seatSelectionDigest?: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingCreateRequest
   */
  bookingRequestId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingCreateRequest
   */
  handoffId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingCreateRequest
   */
  quoteId: string;
  /**
   *
   * @type {Array<FlightBookingTraveler>}
   * @memberof FlightBookingCreateRequest
   */
  travelers: Array<FlightBookingTraveler>;
  /**
   *
   * @type {FlightBookingContact}
   * @memberof FlightBookingCreateRequest
   */
  contact: FlightBookingContact;
  /**
   *
   * @type {FlightBookingPayment}
   * @memberof FlightBookingCreateRequest
   */
  payment: FlightBookingPayment;
}

/**
 * Check if a given object implements the FlightBookingCreateRequest interface.
 */
export function instanceOfFlightBookingCreateRequest(
  value: object
): value is FlightBookingCreateRequest {
  if (!("bookingRequestId" in value) || value["bookingRequestId"] === undefined)
    return false;
  if (!("handoffId" in value) || value["handoffId"] === undefined) return false;
  if (!("quoteId" in value) || value["quoteId"] === undefined) return false;
  if (!("travelers" in value) || value["travelers"] === undefined) return false;
  if (!("contact" in value) || value["contact"] === undefined) return false;
  if (!("payment" in value) || value["payment"] === undefined) return false;
  return true;
}

export function FlightBookingCreateRequestFromJSON(
  json: any
): FlightBookingCreateRequest {
  return FlightBookingCreateRequestFromJSONTyped(json, false);
}

export function FlightBookingCreateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingCreateRequest {
  if (json == null) {
    return json;
  }
  return {
    bagSelectionDigest:
      json["bag_selection_digest"] == null
        ? undefined
        : json["bag_selection_digest"],
    seatSelectionDigest:
      json["seat_selection_digest"] == null
        ? undefined
        : json["seat_selection_digest"],
    bookingRequestId: json["booking_request_id"],
    handoffId: json["handoff_id"],
    quoteId: json["quote_id"],
    travelers: (json["travelers"] as Array<any>).map(
      FlightBookingTravelerFromJSON
    ),
    contact: FlightBookingContactFromJSON(json["contact"]),
    payment: FlightBookingPaymentFromJSON(json["payment"]),
  };
}

export function FlightBookingCreateRequestToJSON(
  json: any
): FlightBookingCreateRequest {
  return FlightBookingCreateRequestToJSONTyped(json, false);
}

export function FlightBookingCreateRequestToJSONTyped(
  value?: FlightBookingCreateRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bag_selection_digest: value["bagSelectionDigest"],
    seat_selection_digest: value["seatSelectionDigest"],
    booking_request_id: value["bookingRequestId"],
    handoff_id: value["handoffId"],
    quote_id: value["quoteId"],
    travelers: (value["travelers"] as Array<any>).map(
      FlightBookingTravelerToJSON
    ),
    contact: FlightBookingContactToJSON(value["contact"]),
    payment: FlightBookingPaymentToJSON(value["payment"]),
  };
}
